import { defineComponent, PropType, computed, ref, watch, onMounted, inject } from 'vue';
import SSelector from '@/components/stemdo-components/s-selector/SSelector.vue';
import SSearch from '@/components/stemdo-components/s-search/SSearch.vue';
import { useI18N } from '@/plugins/i18n';
import SSelectorMultiple from '@/components/stemdo-components/s-selector-multiple/SSelectorMultiple.vue';
import { useStore } from '@/plugins/vuex';
import { Project } from '@/shared/model/project.model';
import CompanyService from '@/sections/admin/entities/company/company.service';

export default defineComponent({
  props: {
    projects: {
      type: Array as PropType<Project[]>,
      required: true
    },
    onSearch: {
      type: Function,
      required: true
    },
    onCompanyChange: {
      type: Function,
      required: true
    },
    companies: {
      type: Array as PropType<Array<{ id: string; desc: string }>>,
      required: true
    }
  },
  components: {
    SSelector,
    SSelectorMultiple,
    SSearch
  },
  setup(props) {
    const store = useStore();
    const i18n = useI18N();
    const companiesSelected = ref<string[]>([]);
    const storedSearch = ref<string>(undefined);

    // companyItems is derived from companies prop
    const companyItems = computed(() => {
      const companiesMap = new Map();
      companiesMap.set('VIEW_ALL', {
        id: 'VIEW_ALL',
        desc: i18n.t('projects-filter-list.filter.all') as string
      });
      props.companies.forEach(company => {
        companiesMap.set(company.id, {
          id: company.id,
          desc: company.desc
        });
      });
      return Array.from(companiesMap.values());
    });

    onMounted(() => {
      const storedFilters = store.getters['pagesStore/manager/projects/filters'];
      if (storedFilters.company) companiesSelected.value = storedFilters.company;
      storedSearch.value = storedFilters.search;
    });

    watch(
      () => companiesSelected.value,
      companies => {
        props.onCompanyChange(companies);
      }
    );

    watch(
      () => i18n.locale,
      () => {}
    ); // No need to update companyItems, computed will react

    return {
      companiesSelected,
      storedSearch,
      companyItems
    };
  }
});
